// extracted by mini-css-extract-plugin
export var csatScore = "_l7-5";
export var header = "_l7-1";
export var panelWrapper = "_l7-2";
export var postPreview = "_l7-3";
export var rightContent = "_l7-0";
export var wrappingText = "_l7-4";